import React from "react";
import "./TrustedStrip.css";
import { FiGlobe, FiAward, FiShield } from "react-icons/fi";

const stats = [
  {
    icon: <FiGlobe size={18} />,
    line1: "Delivered Measurable ROI",
    line2: "Across 4 Continents",
  },
  {
    icon: <FiAward size={18} />,
    line1: "25+ Years Leading Global",
    line2: "Digital Transformation",
  },
  {
    icon: <FiShield size={18} />,
    line1: "Trusted by Fortune 500 &",
    line2: "High-Growth Enterprises",
  },
];

/* Duplicate for seamless infinite loop */
const track = [...stats, ...stats, ...stats, ...stats];

const TrustedStrip = () => (
  <section className="trusted">
    <div className="trusted__row">
      {/* Label — left */}
      <div className="trusted__label">
        <div className="trusted__label-text">
          <p>Trusted by Leaders.</p>
          <p>Built for Impact.</p>
        </div>
      </div>

      {/* Scrolling stat strips */}
      <div className="trusted__marquee-wrap">
        <div className="trusted__track">
          {track.map((stat, i) => (
            <div key={i} className="trusted__stat-item">
              <span className="trusted__stat-icon">{stat.icon}</span>
              <div className="trusted__stat-text">
                <span>{stat.line1}</span>
                <span>{stat.line2}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default TrustedStrip;